export default "__VITE_ASSET__CL0Qx4Zs__"